'use client';

import { Mobile } from '@wwe-portal/ui/components/responsive';
import { PlayerAvatarDesktopList } from './player-avatar-list/player-avatar-list-desktop';
import { PlayerAvatarMobileList } from './player-avatar-list/player-avatar-list-mobile';
import { AvatarFrameListDesktop } from './avatar-frame-list/avatar-frame-list-desktop';
import { AvatarFrameListMobile } from './avatar-frame-list/avatar-frame-list-mobile';
import { DailyWebCoinListDesktop } from './daily-webcoin/daily-webcoin-list-desktop';
import { DailyWebCoinListMobile } from './daily-webcoin/daily-webcoin-list-mobile';
import { EnergyList } from './energy-list/energy-list';

interface WebCoinContentProps {
  webCoinPlayerAvatarRef: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  avatarsList: any[];
  handleWebCoinAvatarCardTitle: (title: string) => string;
  handleItemsPurchase: ({
    price,
    itemId,
    type,
    count,
    title,
  }: {
    itemId: number | string | undefined;
    price: number;
    type: any;
    count?: number;
    title: string;
  }) => void;
  purchasingOffer: any;
  avatarFramesRef: React.RefObject<HTMLDivElement | null>;
  framesList: any[];
  dailyWebCoinOfferRef: React.RefObject<HTMLDivElement | null>;
  webCoinDailyOffers: any[];
  handlePurchaseDailyWebCoinOffer: (offer: any) => void;
  energyPackageList: any[];
  energyPacksRef: React.RefObject<HTMLDivElement | null>;
  isPaymentSuccess?: boolean;
}

export default function WebCoinContent({
  webCoinPlayerAvatarRef,
  pacificDate,
  handleUpdateLiveList,
  avatarsList,
  handleWebCoinAvatarCardTitle,
  handleItemsPurchase,
  purchasingOffer,
  avatarFramesRef,
  framesList,
  dailyWebCoinOfferRef,
  webCoinDailyOffers,
  handlePurchaseDailyWebCoinOffer,
  energyPackageList,
  energyPacksRef,
  isPaymentSuccess,
}: WebCoinContentProps) {
  return (
    <Mobile
      fallback={
        <div className={`shop-content mt-[30px]`}>
          <PlayerAvatarDesktopList
            ref={webCoinPlayerAvatarRef}
            pacificDate={pacificDate}
            handleUpdateLiveList={handleUpdateLiveList}
            avatarsList={avatarsList}
            handleItemsPurchase={handleItemsPurchase}
            purchasingOffer={purchasingOffer}
            handleWebCoinAvatarCardTitle={handleWebCoinAvatarCardTitle}
          />
          <AvatarFrameListDesktop
            ref={avatarFramesRef}
            pacificDate={pacificDate}
            handleUpdateLiveList={handleUpdateLiveList}
            framesList={framesList}
            handleItemsPurchase={handleItemsPurchase}
            purchasingOffer={purchasingOffer}
          />
          <DailyWebCoinListDesktop
            ref={dailyWebCoinOfferRef}
            pacificDate={pacificDate}
            handleUpdateLiveList={handleUpdateLiveList}
            handlePurchaseDailyWebCoinOffer={handlePurchaseDailyWebCoinOffer}
            purchasingOffer={purchasingOffer}
            webCoinDailyOffers={webCoinDailyOffers}
          />
          <EnergyList
            ref={energyPacksRef}
            energyPackageList={energyPackageList}
            handleItemsPurchase={handleItemsPurchase}
            purchasingOffer={purchasingOffer}
            isPaymentSuccess={isPaymentSuccess ?? false}
          />
        </div>
      }
    >
      <div className="shop-content mt-[25px]">
        <PlayerAvatarMobileList
          ref={webCoinPlayerAvatarRef}
          pacificDate={pacificDate}
          handleUpdateLiveList={handleUpdateLiveList}
          avatarsList={avatarsList}
          handleItemsPurchase={handleItemsPurchase}
          purchasingOffer={purchasingOffer}
          isPaymentSuccess={isPaymentSuccess ?? false}
          handleWebCoinAvatarCardTitle={handleWebCoinAvatarCardTitle}
        />

        <AvatarFrameListMobile
          ref={avatarFramesRef}
          pacificDate={pacificDate}
          handleUpdateLiveList={handleUpdateLiveList}
          framesList={framesList}
          handleItemsPurchase={handleItemsPurchase}
          purchasingOffer={purchasingOffer}
          isPaymentSuccess={isPaymentSuccess ?? false}
        />
        <DailyWebCoinListMobile
          ref={dailyWebCoinOfferRef}
          pacificDate={pacificDate}
          handleUpdateLiveList={handleUpdateLiveList}
          handlePurchaseDailyWebCoinOffer={handlePurchaseDailyWebCoinOffer}
          purchasingOffer={purchasingOffer}
          webCoinDailyOffers={webCoinDailyOffers}
        />
        <EnergyList
          ref={energyPacksRef}
          energyPackageList={energyPackageList}
          handleItemsPurchase={handleItemsPurchase}
          purchasingOffer={purchasingOffer}
          isPaymentSuccess={isPaymentSuccess ?? false}
        />
      </div>
    </Mobile>
  );
}
